import { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "@/lib/api";

const DEFAULTS = {
  client_technologies: ["GPON", "EPON", "XGS-PON"],
  dashboard_widgets: ["poles", "cables_length", "clients", "closures", "splitters", "olt", "faults"],
  olt_tx_power_dbm: 3.0,
  min_rx_dbm: -28.0,
  budget_tolerance_db: 3.0,
  budget_wavelength: "1310",
  map_tile_url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
  map_tile_attribution: "© OpenStreetMap contributors",
  map_sat_url: "",
  map_sat_attribution: "",
  map_provider: "osm",
  map_api_key: "",
  eval_watermark: false,
  eval_watermark_text: "WERSJA EWALUACYJNA",
  brand_name: "FiberPass",
  brand_accent: "",
  brand_bg: "",
  brand_theme: "dark",
  license_key: "",
  auto_backup_enabled: false,
  auto_backup_email: "",
  auto_backup_keep: 14,
  cable_colors: { napowietrzny: "#3B82F6", kanalizacja: "#F59E0B", "kanalizacja OPL": "#F97316", "kanalizacja własna": "#EAB308", mikrokanalizacja: "#22C55E", doziemny: "#8B5CF6" },
  marker_icons: {},
  marker_scale: 1,
  marker_size_type: {},
  marker_zoom_min: 0.12,
  marker_zoom_max: 1,
  show_legend: true,
  menu_style: "left",
  sip: { enabled: false, ws_url: "", uri: "", password: "", display_name: "" },
};

const SettingsContext = createContext(null);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);

  const reload = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings({ ...DEFAULTS, ...data });
    } catch { /* keep defaults */ }
  }, []);

  useEffect(() => { reload(); }, [reload]);

  const save = async (upd) => {
    const { data } = await api.put("/settings", upd);
    setSettings({ ...DEFAULTS, ...data });
    return data;
  };

  return (
    <SettingsContext.Provider value={{ settings, reload, save }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () =>
  useContext(SettingsContext) || { settings: DEFAULTS, reload: () => {}, save: async () => {} };
